import "../styles/slider-search-box.scss";
import React, { useEffect, useRef, useState } from "react";
import { GuiSelect } from "./global-ui/gui-select";
import { useUpdateState } from "../utilities/utilities";
import { GuiButton } from "./global-ui/gui-button";
import GuiCustomDatepickerDropdown from "./global-ui/gui-custom-datepicker-dropdown";
const SliderSearchBox = React.memo(
  ({
    createdUserList,
    groupList,
    selectedFilter,
    applyFilter,
    onSearchChange,
    searching,
    minLength = 0,
    searchValue = "",
  }) => {
    function checkObjectForValidValue(obj) {
      let flag = false;

      // Loop through keys of the object
      obj !== undefined &&
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== null && obj[key] !== "") {
            flag = true;
          }
        });

      return flag;
    }

    let isFilterSelected = checkObjectForValidValue(selectedFilter);
    let sync = useRef({}).current;
    // Pre-seed sync.text when a restored search value is provided (back-navigation)
    if (sync.text === undefined && searchValue) {
      sync.text = searchValue;
      sync.lastSearch = searchValue;
    }
    const [isOpen, setIsOpen] = useState(false);

    let [state, updateState] = useUpdateState(() => {
      return {
        messageType: null,
        selectedUser: null,
        selectedGroup: null,
        fromDate: null,
        toDate: null,
        userList: [],
        groupList: [],
        typeOptions: [
          { value: 0, label: "All" },
          { value: 1, label: "Voice" },
          { value: 2, label: "Email" },
          { value: 3, label: "SMS" },
        ],
      };
    });

    const onMessageTypeChange = (name, value) => {
      updateState({ [name]: value });
    };
    const onGroupChange = (name, value) => {
      const selectedOption = state.groupList.find(
        (option) => option.value === value
      );
      updateState({ selectedGroup: selectedOption.value });
    };
    const onUserChange = (name, value) => {
      const selectedOption = state.userList.find(
        (option) => option.value === value
      );
      updateState({ selectedUser: selectedOption.value });
    };
    useEffect(() => {
      let list = createdUserList.map((g) => ({
        value: g.createdUserId,
        label: g.createdUserName,
      }));
      let toGroupList = groupList.map((g) => ({
        value: g.groupId,
        label: g.groupName,
      }));
      updateState({
        messageType: selectedFilter?.messageType,
        selectedUser: selectedFilter?.senderId,
        selectedGroup: selectedFilter?.groupId,
        fromDate: selectedFilter?.startDate,
        toDate: selectedFilter?.endDate,
      });
      updateState({ userList: list, groupList: toGroupList });
    }, [createdUserList, groupList, selectedFilter]);
    useEffect(() => {
      if (!searching && sync.text !== sync.lastSearch) doSearch(sync.text);
    }, [searching]);

    function onChange(e) {
      let text = e.currentTarget.value;
      let shouldSearch =
        !searching &&
        (!minLength ||
          text.length >= minLength ||
          sync.text?.length >= minLength); // Must be at least minLength or have a previous search

      sync.text = text;
      if (shouldSearch) doSearch(sync.text);
    }

    function doSearch(text) {
      sync.lastSearch = text;
      onSearchChange(text);
    }
    function onDateChange(name, value) {
      updateState({ [name]: value });
    }
    function handleFilter() {
      let advanceFilter = {
        startDate: state.fromDate,
        endDate: state.toDate,
        messageType: state.messageType,
        groupId: state.selectedGroup,
        senderId: state.selectedUser,
      };
      setIsOpen(false);
      applyFilter(advanceFilter);
    }
    const handleClear = () => {
      updateState({
        messageType: null,
        selectedGroup: null,
        selectedUser: null,
        fromDate: null,
        toDate: null,
      });
      setIsOpen(false);
      if (
        selectedFilter === undefined ||
        Object.keys(selectedFilter).length === 0
      ) {
        return;
      } else {
        applyFilter({});
      }
    };

    return (
      <div className="slider-search-container">
        <div className="slider-search-box">
          <label className="slider-search-box-label">
            <i className="fal fa-search search-icon"></i>
            <input
              name="search"
              placeholder="Search"
              onChange={onChange}
              defaultValue={searchValue}
              data-qa="search"
            />
          </label>

          <GuiButton
            className={`btn-no-outline${
              isOpen || isFilterSelected ? "-active" : "-default"
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <i
              className={`fa fa-sliders  filter-icon${
                isOpen || isFilterSelected ? "-active" : "-default"
              }`}
            ></i>
          </GuiButton>
        </div>
        <div className="slider-dropdown">
          {isOpen && (
            <div className="slider-dropdown-menu">
              <div className="slider-dropdown-menu-item">
                <span className="slider-dropdown-menu-item-header">
                  Filters
                </span>
              </div>
              <div className="slider-dropdown-menu-item">
                <GuiSelect
                  label="Message Type"
                  name="messageType"
                  value={state.messageType}
                  onChange={(name, option) =>
                    onMessageTypeChange(name, option.value)
                  }
                  options={state.typeOptions}
                />
              </div>
              <div className="slider-dropdown-menu-item">
                <GuiSelect
                  label="From"
                  name="from"
                  value={state.selectedUser}
                  onChange={(name, option) => onUserChange(name, option.value)}
                  options={state.userList}
                />
              </div>
              <div className="slider-dropdown-menu-item">
                <GuiSelect
                  label="Includes Group"
                  name="group"
                  value={state.selectedGroup}
                  onChange={(name, option) => onGroupChange(name, option.value)}
                  options={state.groupList}
                />
              </div>
              <div className="slider-dropdown-menu-item">
                <GuiCustomDatepickerDropdown
                  dateLabel="From Date"
                  dateSelected={selectedFilter?.startDate || null}
                  onDateChange={(date) => onDateChange("fromDate", date)}
                ></GuiCustomDatepickerDropdown>
              </div>
              <div className="slider-dropdown-menu-item">
                <GuiCustomDatepickerDropdown
                  dateLabel="To Date"
                  dateSelected={selectedFilter?.endDate || null}
                  onDateChange={(date) => onDateChange("toDate", date)}
                ></GuiCustomDatepickerDropdown>
              </div>
              <div className="slider-dropdown-menu-btns">
                <GuiButton onClick={handleClear} className="clear-btn">
                  Clear
                </GuiButton>
                <GuiButton onClick={handleFilter}>Search</GuiButton>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);
export default SliderSearchBox;
